import { gql } from '@apollo/client';

export const UPDATE_EXTERNAL_POST_MUTATION = gql`
  mutation UpdateExternalPost($data: updateExternalPostInput!) {
    updateExternalPost(input: $data) {
      externalPost {
        id
        bannerImg {
          url
          id
          formats
        }
        bannerImgUrl
        hotel {
          id
        }
      }
    }
  }
`;
